var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex-line pifa-item",class:{ active: _vm.active }},[_c('div',{staticClass:"name"},[_vm._v("· "+_vm._s(_vm.data.name))]),_vm._l((_vm.data.values),function(val,idx){return _c('div',{key:idx,staticClass:"value"},[_vm._v(_vm._s(val)+"%")])})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }